import { isAllowed } from "lib/permToolkit"

//utilisateur
export default (subject, action, ressource) => {
    return isAllowed(subject, "GestionUtilisateurs");
}